import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { Apis } from 'app/Apis/Apis'
import { Box } from '@mui/system'
import CkEditor from 'app/components/CkEditor/CkEditor'
import AddPolicy from '../../../components/PrivacyPolicy/AddPolicy'
import EditPolicy from '../../../components/PrivacyPolicy/EditPolicy'
import { Container } from '../utils/Utils'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'

const TermsAndConditions = () => {
    const [editorData, setEditorData] = useState(null)
    const [termsAndConditionsData, setTermsAndCondiyionsData] = useState('')
    const [showEditor, setShowEditor] = useState(false)
    const [showEditorWithData, setShowEditorWithData] = useState(false)
    const [showAddTerms, setShowAddTerms] = useState(false) // Control rendering of AddPolicy
    const [runUseEffect, setRunUseEffect] = useState(false)

    const config = {
        headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
    }

    useEffect(() => {
        async function fetchTerms() {
            try {
                const res = await axios.get(
                    `${Apis.getTermsAndConditions}`,
                    config
                )

                console.log(res, "res terms")
                let terms = res.data.data?.termsAndConditions
                console.log(terms, "terms")
                setTermsAndCondiyionsData(terms)
                setEditorData(terms)
                if (!terms) {
                    setShowEditor(false)
                    setShowAddTerms(true) // Show the AddPolicy component after data has been fetched
                }
            } catch (error) {
                console.log(error)
            }
        }
        fetchTerms()
    }, [runUseEffect])

    async function addTerms() {
        await axios
            .post(
                `${Apis.addTermsAndConditions}`,
                { termsAndConditions: editorData },
                config
            )
            .then((res) => {
                if (res.data) {
                    setRunUseEffect(!runUseEffect)
                    setShowEditorWithData(false)
                    setShowEditor(false)
                }
                setShowEditorWithData(false)
            })
            .catch((err) => {
                console.log(err)
            })
    }

    const goBack = () => {
        setRunUseEffect(!runUseEffect)
                    setShowEditorWithData(false)
                    setShowEditor(false)
    }

    return (
       < Container>
            <Box
                sx={{
                    fontWeight: 600,
                    width: '100%',
                    justifyContent: 'space-between',
                }}
            >
                Terms and conditions
            </Box>

            {termsAndConditionsData && !showEditorWithData && (
                <EditPolicy
                    buttonText={'Edit terms and conditions'}
                    setShowEditorWithData={setShowEditorWithData}
                />
            )}

            <Box py="12px" />
            {termsAndConditionsData && !showEditorWithData && (
                <div
                    dangerouslySetInnerHTML={{ __html: termsAndConditionsData }}
                ></div>
            )}
            {!showEditor && showAddTerms && (
                <AddPolicy
                    buttonText={'Add terms and conditions'}
                    setShowEditor={setShowEditor}
                    setShowAddButton={setShowAddTerms}
                />
            )}
            {showEditor && !showAddTerms && (
                <>
               <Box sx={{ padding: '15px 0px' }}>
                 <ArrowBackIcon style={{cursor:"pointer"}} onClick={() => goBack()}/>
                </Box>
                <CkEditor
                    setEditorData={setEditorData}
                    addFunction={addTerms}
                />
                </>
            )}

            {showEditorWithData && termsAndConditionsData && (
                <>
                 <Box sx={{ padding: '15px 0px' }}>
                 <ArrowBackIcon style={{cursor:"pointer"}} onClick={() => goBack()}/>
                </Box>
                <CkEditor
                    setEditorData={setEditorData}
                    addFunction={addTerms}
                    initialData={termsAndConditionsData}
                    />
                    </>
            )}
       </Container>
    )
}

export default TermsAndConditions
